module.exports = __webpack_public_path__ + "static/media/Bud.17b3c6a9.png";